import React from 'react';

type State = {
  hasError: boolean;
};

class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <>Er is iets fout gegaan, probeer het opnieuw</>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
